module.exports = __webpack_public_path__ + "img/folder.d04db7aa.svg";